import react from 'react';


const DownloadTheApp = () => {
    return (
        <div style={{padding: '20px', textAlign: 'center'}}>
            <h1>Download the App</h1>
            <p>To provide the best experience, please download our mobile app.</p>
            <a href="https://play.google.com/apps/internaltest/4699602396115367608" target="_blank" rel="noopener noreferrer">
                <button style={{padding: '10px 20px', fontSize: '16px'}}>Download Now</button>
            </a>
        </div>
    );
}

export default DownloadTheApp;